import * as AgmNames from "./const/agm-names";
import { objectValues } from "./helper";
import { Glue42Core } from "@glue42/core";
import AppManagerImpl from "./app-manager";
import { Configuration, GetApplicationsMethodResult } from "./types";

/** Retrieves application snapshot from ACS */
export default function snapshot(agm: Glue42Core.AGM.API, appManager: AppManagerImpl): Promise<Configuration> {
    return new Promise<Configuration>((resolve, reject) => {
        agm.invoke<GetApplicationsMethodResult>(AgmNames.GetApplicationsMethodName, { skipIcon: true })
            .then((response) => {
                const data = response.returned;
                const configuration = response.returned.configuration ?? {};
                if (!data) {
                    resolve(configuration);
                }

                const applications = data.applications;
                if (!applications) {
                    resolve(configuration);
                }

                objectValues(applications).map((item) => appManager.handleAppAdded(item));

                resolve(configuration);
            })
            .catch((err: Error) => reject(`Error getting application snapshot: ${err.message}`));
    });
}
